export const SUMMARY = 'summary';
export const VIEW = 'view';
export const PREVIEW = 'preview';